import {callTargetedAction} from 'client/framework';
import type {GuessModelV1} from '@albert-io/models';
import actions from 'components/QuestionTypes/questionType.actions';

export default function loadGuess(questionStoreName: string, guess: GuessModelV1) {
  callTargetedAction({
    name: actions.LOAD_GUESS,
    targetStore: questionStoreName,
    payload: guess
  });
}
